/* @generated */
import { useMediaQuery } from "@react-hookz/web";
const QUERY = "(prefers-reduced-motion: reduce)";
const getInitialState = () => "window" in globalThis && "matchMedia" in window ? window.matchMedia(QUERY).matches : false;
const usePrefersReducedMotion = () => {
  const prefersReducedMotion = useMediaQuery(QUERY) || getInitialState();
  return { hasReducedMotion: prefersReducedMotion };
};
export {
  usePrefersReducedMotion
};
